import { HttpClient } from '@adapters/HttpClient';

export interface Rate {
    id: number;
    title: string;
    status: 'active' | 'inactive';
    created_at: string;
}

export interface RatesResponse {
    data: Rate[];
    meta: {
        current_page: number;
        per_page: number;
        total: number;
    };
}

export interface RatesParams {
    sorting?: {
        column?: 'id' | 'title' | 'description' | 'frequency' | 'expires_at' | 'status' | 'created_at' | 'updated_at';
        direction?: 'asc' | 'desc';
    };
    per_page?: number;
    page?: number;
}

export class RatesApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getRates(params: RatesParams = {}): Promise<RatesResponse> {
        const queryParams: Record<string, any> = {};

        if (params.sorting?.column) {
            queryParams['sorting[column]'] = params.sorting.column;
        }
        if (params.sorting?.direction) {
            queryParams['sorting[direction]'] = params.sorting.direction;
        }
        if (params.per_page) {
            queryParams.per_page = params.per_page;
        }
        if (params.page) {
            queryParams.page = params.page;
        }

        const response = await this.httpClient.get<RatesResponse>('/rates', queryParams);
        return response;
    }
}

